declare namespace $ {

	type $mol_view__sub_bog_ui_app_tooltip_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_tooltip_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_tooltip_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_tooltip_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_tooltip_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__hint_bog_ui_app_tooltip_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_bog_ui_app_tooltip_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_bog_ui_app_tooltip_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_bog_ui_app_tooltip_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_bog_ui_app_tooltip_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_bog_ui_app_tooltip_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_open__hint_bog_ui_app_tooltip_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_open['hint'] >
	>
	type $mol_button_open__accept_bog_ui_app_tooltip_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_open['accept'] >
	>
	type $mol_button_open__files_bog_ui_app_tooltip_14 = $mol_type_enforce<
		ReturnType< $bog_ui_app_tooltip['demo_files'] >
		,
		ReturnType< $mol_button_open['files'] >
	>
	type $mol_view__attr_bog_ui_app_tooltip_15 = $mol_type_enforce<
		({ 
			'title': string,
		}) 
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_bog_ui_app_tooltip_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_tooltip_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_ui_app_tooltip extends $mol_page {
		description( ): string
		Description( ): $mol_view
		usage_title( ): string
		Usage_title( ): $mol_view
		usage_code( ): string
		Usage_code( ): $mol_view
		demo_title( ): string
		Demo_title( ): $mol_view
		demo_hint( ): string
		Demo_hint( ): $mol_view
		Btn_simple( ): $mol_button_minor
		Btn_long( ): $mol_button_minor
		Btn_icon_glyph( ): $mol_icon_cog
		Btn_icon( ): $mol_button_minor
		demo_files( next?: readonly(File)[] ): readonly(File)[]
		Btn_input( ): $mol_button_open
		Inline_text( ): $mol_view
		Demo( ): $mol_view
		title( ): string
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=tooltip.view.tree.d.ts.map